(function(){
    'use strict';
   
    angular
    .module('app')
    .controller('AppController', AppController)
    .constant("prefixCampos", "_campo_");
 
    AppController.$inject = ['RedirectService','PaginasService',"$http","$timeout","$uibModal", "$log", "$document","$sce",'prefixCampos'];
   
    function AppController(RedirectService,PaginasService,$http,$timeout,$uibModal, $log, $document,$sce,prefixCampos)
    {                        
        var vm = this; 
        vm.prefixCampos = prefixCampos;    
        vm.pagesimple = "";
        vm.datos = []; 
        vm.contadorBloques_1 = 1; 
        vm.loading = true;
        vm.horaSave = "";
        vm.categoriasBloques = [];
        vm.previewContent = ""; 
        vm.previewShow = false;
        vm.page_id = "";
        vm.lang_id_copy = 0;
        vm.ultimoSaveObj = [];
        vm.duplicar = "";

        vm.idiomas = [];

        vm.lang_id = "";
        //alert("E");

        vm.hanHabidoCambios = function(){
            return angular.equals(vm.datos, vm.ultimoSaveObj);
        }
            
        vm.showColumns = function(dato){
            if(dato.hoverColumns){
                dato.hoverColumns = false;
            }else{
                dato.hoverColumns = true;
            }
        } 
        vm.preview = function(){
            var json = $('.infoPage').serializeObject();
            var datos = vm.datos;
            var lang_id = vm.lang_id;
            var page_id = vm.page_id;
            $('#preview_datos').val(JSON.stringify(datos));
            $('#preview_json').val(JSON.stringify(json));
            $('#preview_lang_id').val(lang_id);
            $('#preview_page_id').val(page_id);
            $('#previewForm').submit();
            /*PaginasService.getPreview(vm.datos,function(data){
                $timeout(function(){
                    vm.previewContent = data.html;
                    vm.previewShow = true;
                })
            });*/
        }
        vm.closeIframe = function(){
            vm.previewShow = false;
            vm.previewContent = "";
            
        }
                                                                                                         
        vm.cambiarColumnas = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length;cont++){
                if(typeof dato.columnas[cont] == 'undefined'){
                    var datoAInsertar = new Object();
                    datoAInsertar.bloques = new Array();
                    dato.columnas.push(datoAInsertar);
                }
                var totalColumnas = 12;

                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
                dato.columnas[cont].medida = division;
                dato.columnas[cont].layout = partesSeparadas[cont];
            }
            dato.fila.layout = value;
            //console.log(value);
            var contSeg = cont;
            for(cont;cont<columnasActuales;cont++){
                for(var contBloq=0;contBloq<dato.columnas[contSeg].bloques.length;contBloq++){
                        dato.columnas[0].bloques.push(dato.columnas[contSeg].bloques[contBloq]);
                }
                dato.columnas.splice(contSeg, 1);
            }
        } 

        vm.customLayout = function(dato){
            dato.custom = true;
        }

        vm.cambiarColumnasTablet = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];

                dato.columnas[cont].medida_tablet = division;
                dato.columnas[cont].layout_tablet = partesSeparadas[cont];
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_tablet = "";
                    dato.columnas[cont].layout_tablet = "";
                }
            }
            dato.fila.layout_tablet = value;
        } 
        vm.cambiarColumnasMobile = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];

                dato.columnas[cont].medida_mobile = division;
                dato.columnas[cont].layout_mobile = partesSeparadas[cont];
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_mobile = "";
                    dato.columnas[cont].layout_mobile = "";
                }
            }
            dato.fila.layout_mobile = value;
        } 
               
        vm.sortableOptions = {
            handle: '.movimiento',
            connectWith: ".columnaAdmin",
            placeholder:'app2',
            stop:function(){
                console.log(vm.datos);
            }
          }; 

        vm.remove = function(array, index){
            array.splice(index, 1);
        }
                         
        vm.borrarBloque = function(data){
            var search = false;
            for(var cont=0;cont<vm.datos.length && !search;cont++){
                for(var cont2=0;cont2<vm.datos[cont].columnas.length && !search;cont2++){
                    for(var cont3=0;cont3<vm.datos[cont].columnas[cont2].bloques.length && !search;cont3++){
                        if(vm.datos[cont].columnas[cont2].bloques[cont3] == data){
                            vm.datos[cont].columnas[cont2].bloques.splice(cont3, 1);
                            search = true;
                        }
                    }
                }
            }
        } 
                 
        vm.borrarFila = function(index){
            vm.datos.splice(index,1);
        }

        vm.columnaModalEditar = "";
        vm.columnaModal = function(dato){
            vm.columnaModalEditar = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'colunaModal.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.extraclass = "";
                    $scope.hiddendesk = "";
                    $scope.hiddentab = "";
                    $scope.hiddenmob = "";
                    console.log(dato.config);
                    if(dato.config != null){
                        if(typeof dato.config.extraclass != 'undefined'){
                            $scope.extraclass = dato.config.extraclass;
                        }
                        if(typeof dato.config.hiddendesk != 'undefined'){
                            $scope.hiddendesk = eval(dato.config.hiddendesk);
                        }
                        if(typeof dato.config.hiddentab != 'undefined'){
                            $scope.hiddentab = eval(dato.config.hiddentab);
                        }
                        if(typeof dato.config.hiddenmob != 'undefined'){
                            $scope.hiddenmob = eval(dato.config.hiddenmob);
                        }
                    }
                    $scope.okForm = function(){
                        if(dato.config == null){
                            dato.config = {};
                        }
                        dato.config.extraclass = $scope.extraclass;
                        dato.config.hiddendesk = $scope.hiddendesk;
                        dato.config.hiddentab = $scope.hiddentab;
                        dato.config.hiddenmob = $scope.hiddenmob;
                        vm.columnaModalEditar.close();
                    }
                    $scope.koForm = function(){
                        vm.columnaModalEditar.close();
                    }
                  }
              });
        }


        vm.modalRedirectAlias = "";   
        vm.modalRedirectSlug = "";   
        vm.saveDatos = function(){  
           vm.loading = true;
           PaginasService.saveDatos(vm,function(data){
                $('#idioma option').each(function(){
                    if($(this).val()!=data.lang_id){
                        $(this).remove();
                    }
                })
                if(data.aliasAnterior != data.alias && data.aliasAnterior!=""){
                    vm.modalRedirectAlias = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'redirectalias.html',
                      size: 'lg',
                      controller: function($scope) {
                        $scope.urlOrigenAlias = data.urlOrigenAlias;
                        $scope.urlDestinoAlias = data.urlDestinoAlias;
                        $scope.koForm = function(){
                            vm.modalRedirectAlias.close();
                        }

                        $scope.okForm = function(){
                            RedirectService.setRedirectAlias(data,function(data){
                                vm.modalRedirectAlias.close();
                            });
                        }
                      }
                    });
                }

                if(data.slugAnterior != data.slugpagina && data.slugAnterior!=""){
                    vm.modalRedirectSlug = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'redirectslug.html',
                      size: 'lg',
                      controller: function($scope) {
                        $scope.urlOrigenSlug = data.urlOrigenSlug;
                        $scope.urlDestinoSlug = data.urlDestinoSlug;
                        $scope.koForm = function(){
                            vm.modalRedirectSlug.close();
                        }

                        $scope.okForm = function(){
                            RedirectService.setRedirectSlug(data,function(data){
                                vm.modalRedirectSlug.close();
                            });
                        }
                      }
                    });
                }

                $timeout(function(){
                    vm.duplicar="";
                    vm.datos = data.datos;
                    vm.horaSave = data.horaSave;
                    vm.ultimoSaveObj = angular.copy(data.datos);
                    vm.page_id = data.page_id;
                    vm.aliaspagina = data.alias;
                    vm.lang_id = data.lang_id;
                    vm.slugpagina = data.slugpagina;
                    vm.loading = false;
                    
                })
           });
        }    
                                          

        vm.modalEditarSelect = "";
        vm.opcionesextra = {};
        vm.creartype = function(type,model_id,fieldName,fieldMuestra){
            if(typeof(vm.opcionesextra[fieldName])=='undefined'){
                vm.opcionesextra[fieldName] = [];
            }
            vm.modalEditarSelect = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'myModalContentSelect2.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.appVm = vm;
                    $scope.type = type;
                    $scope.model_id = model_id;
                    /*$scope.appVm = vm;
                    $scope.campos = data.campos;
                    $scope.bloque = bloque;
                    //console.log($scope.bloque);
                    vm.templates = data.templates;
                    vm.camposActual = [];
                    for(var cont=0;cont<data.campos.length;cont++){
                        //console.log(data.campos[cont]["value"]);
                          vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = data.campos[cont]["value"];
                    } 
                    $scope.camposActual = vm.camposActual;
                    $scope.camposHtml = data.camposHtml;*/
                    $scope.okForm = function(contPass){
                        contPass.saveContenido(function(data,camposActual){
                            if(model_id==''){
                                vm.opcionesextra[fieldName].push({"value":data.content_id,"name":camposActual["_campo_"+fieldMuestra],"selected":true});
                            }
                            vm.modalEditarSelect.close();
                        });
                    }
                    $scope.koForm = function(){
                        vm.modalEditarSelect.close();
                    }
                  }
                });
        }

        vm.modalEditar = "";
        vm.camposActual = [];
        vm.templates = [];
        vm.edit = function (bloque) {
            vm.opcionesextra = {};
            vm.loading = true;
            PaginasService.getBloqueEdit(vm,bloque,function(data){
                 bloque.id = data.datos[0].bloque.id;
                 bloque.block_id = data.datos[0].bloque.block_id;
                 bloque.template_id = data.datos[0].bloque.template_id.toString();
                 vm.loading = false;

                 vm.modalEditar = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'myModalContent.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.appVm = vm;
                    $scope.campos = data.campos;
                    $scope.bloque = bloque;
                    //console.log($scope.bloque);
                    vm.templates = data.templates;
                    vm.camposActual = [];
                    for(var cont=0;cont<data.campos.length;cont++){
                        //console.log(data.campos[cont]["value"]);
                          vm.camposActual[vm.prefixCampos+data.campos[cont]["name"]] = data.campos[cont]["value"];
                    } 
                    $scope.camposActual = vm.camposActual;
                    $scope.camposHtml = data.camposHtml;
                    $scope.okForm = function(){
                        for(var cont=0;cont<bloque.campos.length;cont++){
                            bloque.campos[cont].value = vm.camposActual[vm.prefixCampos+bloque.campos[cont].name];
                        } 
                        vm.modalEditar.close();
                    }
                    $scope.koForm = function(){
                        vm.modalEditar.close();
                    }
                  }
                });
            })
        }

        vm.duplicarBlock = function (bloque,columna) {
            var bloqueClone = angular.copy(bloque);
            bloqueClone.id = "";
            if(typeof bloqueClone.data.node != 'undefined'){
                bloqueClone.data.node[0].id="";
            }
            var resultado = 0;
            for(var cont=0;cont<columna.bloques.length;cont++){
                if(columna.bloques[cont]==bloque){
                    resultado = cont;
                }
            }
            columna.bloques.splice(resultado, 0, bloqueClone);
        }
     
        vm.selectedColumna = function(dato, selected){
            if(dato.fila.layout==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaTablet = function(dato, selected){
            if(dato.fila.layout_tablet==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaMobile = function(dato, selected){
            if(dato.fila.layout_mobile==selected){
                return "selected";
            }  
            return false;
        } 

        vm.modalBlocksVar = "";
        vm.modalBlocks = function(columna){
            vm.modalBlocksVar = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'tiposContenido.html',
              size: 'lg',
              controller: function($scope) {
                $scope.listadoBloques = vm.listadoBloques;
                $scope.categoriasBloques = vm.categoriasBloques;
                $scope.koForm = function(){
                    vm.modalBlocksVar.close();
                }
                function Bloque(){
                    this.id = "";
                    this.block_id = "";
                    this.campos = [];
                    this.data = null;
                }
                function BloqueData(){
                    this.lang_id = "";
                    this.select = 0;
                    this.type = "";
                }
                $scope.addBlockColumn = function(bloqueVar){
                    var newBloque = new Bloque();
                    var bloqueVarClone = jQuery.extend(true, {}, bloqueVar);
                    newBloque.id = "";
                    newBloque.block_id = bloqueVarClone.id;
                    newBloque.campos = bloqueVarClone.campos;
                    newBloque.data = new BloqueData();
                    newBloque.data.lang_id = vm.lang_id;
                    newBloque.data.select = 0;
                    newBloque.data.type = bloqueVarClone.type;
                    columna.bloques.push(newBloque);
                    vm.modalBlocksVar.close();
                    vm.edit(columna.bloques[columna.bloques.length-1]);
                }
                $scope.addFilaBlock = function(){
                    var datos = new Object();
                    datos["fila"] = new Object();
                    datos["fila"].layout = "1/1";
                    datos["columnas"] = new Array();
                    datos["columnas"][0] = new Object();
                    datos["columnas"][0].medida = 12;
                    datos["columnas"][0].medida_tablet = "";
                    datos["columnas"][0].medida_mobile = "";
                    datos["columnas"][0].layout = "1/1";
                    datos["columnas"][0].layout_tablet = "";
                    datos["columnas"][0].layout_mobile = "";
                    datos["columnas"][0].config = {};
                    datos["columnas"][0].config.hiddendesk = false;
                    datos["columnas"][0].config.hiddentab = false;
                    datos["columnas"][0].config.hiddenmob = false;
                    datos["columnas"][0].config.flex = false;
                    datos["columnas"][0].config.background = "";
                    datos["columnas"][0].config.paddingtop = "";
                    datos["columnas"][0].config.paddingbottom = "";
                    datos["columnas"][0].config.paddingleft = "";
                    datos["columnas"][0].config.paddingright = "";

                    datos["columnas"][0].bloques = new Array();
                    columna.bloques.push(datos);
                    vm.modalBlocksVar.close();
                }

              }
            });
        }

        vm.modalAjustesFila = "";
        vm.ajustesFila = function(dato){
            vm.modalAjustesFila = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'ajustesfila.html',
              size: 'lg',
              controller: function($scope) {
                $scope.dato = dato;
                //console.log(dato);
                $scope.koForm = function(){
                    vm.modalAjustesFila.close();
                }
                $scope.okForm = function(){
                    vm.modalAjustesFila.close();
                }
                $scope.selectedColumna = function(dato, selected){
                    return vm.selectedColumna(dato,selected);
                }
                $scope.selectedColumnaTablet = function(dato, selected){
                    return vm.selectedColumnaTablet(dato,selected);
                }
                $scope.selectedColumnaMobile = function(dato, selected){
                    return vm.selectedColumnaMobile(dato,selected);
                }
                $scope.cambiarColumnas = function(dato,value){
                    vm.cambiarColumnas(dato,value);
                }
                $scope.cambiarColumnasTablet = function(dato,value){
                    vm.cambiarColumnasTablet(dato,value);
                }
                $scope.cambiarColumnasMobile = function(dato,value){
                    vm.cambiarColumnasMobile(dato,value);
                }
              }
            });
        }
                             
        vm.getBloques = function(){  
            PaginasService.getAllBlocks(vm,function(data){
                $timeout(function(){
                    vm.datos = data.datos;
                    vm.ultimoSaveObj = angular.copy(data.datos);
                    vm.loading = false;
                    vm.contadorBloques_1 = data.select;
                })
            });
        } 
     
        vm.addFila = function(){
            var datos = new Object();
            datos["fila"] = new Object();
            datos["fila"].layout = "1/1";
            datos["columnas"] = new Array();
            datos["columnas"][0] = new Object();
            datos["columnas"][0].medida = 12;
            datos["columnas"][0].medida_tablet = "";
            datos["columnas"][0].medida_mobile = "";
            datos["columnas"][0].layout = "1/1";
            datos["columnas"][0].layout_tablet = "";
            datos["columnas"][0].layout_mobile = "";
            datos["columnas"][0].config = {};
            datos["columnas"][0].config.hiddendesk = false;
            datos["columnas"][0].config.hiddentab = false;
            datos["columnas"][0].config.hiddenmob = false;
            datos["columnas"][0].config.flex = false;
            datos["columnas"][0].config.background = "";
            datos["columnas"][0].config.paddingtop = "";
            datos["columnas"][0].config.paddingbottom = "";
            datos["columnas"][0].config.paddingleft = "";
            datos["columnas"][0].config.paddingright = "";
            datos["columnas"][0].bloques = new Array();
            vm.datos.push(datos);           
        }

        vm.listadoBloques = [];
 
        vm.init = function(page_id,lang_id_copy,duplicar){
            vm.page_id = page_id;
            vm.lang_id_copy = lang_id_copy;
            vm.duplicar = duplicar;
            //console.log(vm.lang_id_copy);
            PaginasService.getFormSimple(vm.page_id,vm.lang_id,function(data){
                $timeout(function(){
                    vm.pagesimple = data.data;
                    vm.listadoBloques = data.bloques;
                    vm.categoriasBloques = data.categorias;
                    vm.idiomas = data.idiomas;
                })
            });
        }

      
    }

})();